module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "fileform",
    on: {
      "click": _vm.selectImage
    }
  }, [_c('span', {
    staticClass: "drop-files"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c0abbb1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image/imageUpload.vue
// module id = 670
// module chunks = 1